export default function toHighlightCategory(target) {
    const list = document.querySelector('#nav_options');
    const cards = [...list.children];
    for (const card of cards) {
        target == card.id
            ? card.classList.add('highlighted')
            : card.classList.remove('highlighted');
    }
}
